export default "__VITE_ASSET__DnpxNUjH__"